<template>
    <div class="pop-wrap">
        <div class="pop-cont">
            <div class="title">
                <span>你的专属口令已复制</span>
            </div>
            <div class="desc">
                <span class="s-txt">1. 选择微信好友或微信群，粘贴后发出</span>
                <span class="s-txt">2. 好友下载【七猫免费小说】并注册账号</span>
                <span class="s-txt">3. 好友复制你的口令，打开七猫小说App</span>
            </div>
            <div class="example">
                <img src="@divide/assets/images/marathon_img_invitation_wechat.jpg" alt="" />
            </div>
            <div class="btn g-flex-center-center" @click="jumpWechat"><i class="icon-wechat"></i><span>去微信粘贴</span></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import '@q-front-npm/h5-ui/lib/index.css';
import { ref, watch, getCurrentInstance, onMounted } from 'vue';
import { jsbSingle } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@qm-activity/common/store/common';
const storeCommon = useStoreCommon();
const jumpWechat = async() => {
    const params = {
        scene: 0, // 0 聊天界面  1 朋友圈,
        type: 'text',
        text: storeCommon.userInfo.invite_code_pass,
    };
    jsbSingle.callNative('app', 'share', params, (data: any) => {
        console.log('跳转微信', data);
    });
};
onMounted(async() => {});
</script>

<style lang="scss" scoped>
.pop-wrap {
    position: relative;
    padding: 40px 50px;
    box-sizing: border-box;
    .pop-cont {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        background: #fff;
        .title {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 24px;
            font-weight: 600;
            font-size: 32px;
            color: #111111;
            line-height: 44px;
            .avatar {
                margin-right: 12px;
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }
        }
        .desc {
            margin-bottom: 38px;

            .s-txt {
                display: block;
                margin-bottom: 4px;
                font-size: 26px;
                color: #666666;
                line-height: 40px;
            }
        }
        .example {
            margin-bottom: 42px;
            width: 360px;
            height: 232px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .btn {
            width: 416px;
            height: 88px;
            background: linear-gradient(270deg, #ff603d 0%, #ff640b 51%, #ff7e18 100%);
            border-radius: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 28px;
            color: #ffffff;
            line-height: 40px;
            .icon-wechat {
                display: block;
                margin-right: 12px;
            }
        }
    }
}
</style>
